// extracted by mini-css-extract-plugin
export default {"messenger-content":"styles_messenger-content__yCHIT","messengerContent":"styles_messenger-content__yCHIT"};